import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["section", "feedback"]

  toggleFeedback(event) {
    const checkbox = event.target
    const section = checkbox.closest("[data-section-revision-target='section']")
    if (!section) return

    const feedbackDiv = section.querySelector("[data-section-revision-target='feedback']")
    if (!feedbackDiv) return

    if (checkbox.checked) {
      feedbackDiv.classList.remove("hidden")
    } else {
      feedbackDiv.classList.add("hidden")
    }
  }
}
